var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHaulerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 42 42"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#hauler-icon_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 20,
  r: 15.273,
  fill: "#FFA351",
  stroke: "#fff",
  strokeWidth: 1.455
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M11 10h20v20H11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.073 13.333h-1.74v.911h1.74zm7.97 1.784h4.348L31 18.595v4.348h-.87a2.609 2.609 0 0 1-5.217 0h-2.609a2.609 2.609 0 0 1-5.217 0 2.609 2.609 0 0 1-5.217 0H11v-1.74h1.534q.18-.2.398-.361a3.478 3.478 0 0 1 1.546-6.595h6.087a3.48 3.48 0 0 1 3.478 3.46zm0 2.628a3.48 3.48 0 0 1-2.529 3.328q.066.064.126.13h3.937-1.534zm-3.478 5.198v-.006a.87.87 0 1 0 0 .006m5.217-6.522h2.174l1.709 2.174h-3.883zm-10.434 6.522a.87.87 0 1 1-1.74 0 .87.87 0 0 1 1.74 0m13.043 0a.87.87 0 1 1-1.739 0 .87.87 0 0 1 1.74 0M14.478 15.89h6.087a1.836 1.836 0 1 1 0 3.671h-6.087a1.836 1.836 0 1 1 0-3.671",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "hauler-icon_svg__a",
  width: 42,
  height: 42,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_39813"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1_39813",
  result: "effect2_dropShadow_1_39813"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 2,
  result: "effect3_dropShadow_1_39813"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_1_39813",
  result: "effect3_dropShadow_1_39813"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_39813",
  result: "shape"
})))));
export { SvgHaulerIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/hauler-icon.bb8b557b.svg";